export default __webpack_public_path__ + "static/media/banner5.13562496.webp";